<script>
  export let middle = false
</script>

<figure class="blockquote" class:middle>
  <blockquote class="content"><slot /></blockquote>
  {#if $$slots.cite}
    <figcaption class="cite"><slot name="cite" /></figcaption>
  {/if}
</figure>

<style>
  .blockquote {
    position: relative;
    max-width: var(--current-max-width, 34em);
    min-height: 4rem;
    padding-left: 2.25rem;
    font-size: var(--current-font-size, 1.25rem);
    line-height: var(--current-line-height, 1.45);
  }

  .blockquote::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.2rem;
    width: 1.25rem;
    height: calc(100% - 0.5rem);
    border-radius: var(--border-radius-full);
    background: rgb(var(--rgb-highlight));
  }

  .content::before,
  .content::after {
    content: '';
    position: absolute;
    left: 0.36rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: var(--border-radius-full);
    background: #fffdf8;
  }

  .content::before {
    top: 0.6rem;
  }

  .content::after {
    top: auto;
    bottom: 0.7rem;
  }

  .cite {
    color: rgb(var(--rgb-muted));
    margin-top: 0.5rem;
    display: flex;
    gap: 0.25rem;
    justify-content: flex-start;
    transform: translateY(-2px);
  }
</style>
